export { default as playIconTemplate } from './playIcon.dot';
export { default as pauseIconTemplate } from './pauseIcon.dot';
export { default as controlTemplate } from './control.dot';



// WEBPACK FOOTER //
// ./default-modules/ui/controls/play/templates/index.ts